(function () {
  'use strict';

  const BANTOA_CLASS = 'bantoa-plp-row';
  const GRID_SELECTOR = '#collection-grid';
  // Algolia usa .col > .data-card-wrapper, nativo usa [data-collection-product]
  const PRODUCT_SELECTOR =
    ':scope > .col:not(.' +
    BANTOA_CLASS +
    '):not([data-plp-banner]), :scope > [data-collection-product]';
  const BP_XL = 1200;

  // Leggi config dal tag script
  const scriptTag = document.getElementById('bantoa-plp-config');
  const bantoaTitle = scriptTag ? scriptTag.dataset.title : '';
  const ROWS_INTERVAL = scriptTag ? parseInt(scriptTag.dataset.rowsInterval, 10) || 5 : 5;
  const MAX_OUTFIT = scriptTag ? parseInt(scriptTag.dataset.maxOutfit, 10) || 6 : 6;
  const PADDING_TOP = scriptTag ? parseInt(scriptTag.dataset.paddingTop, 10) || 16 : 16;
  const PADDING_BOTTOM = scriptTag ? parseInt(scriptTag.dataset.paddingBottom, 10) || 16 : 16;

  function getColumnCount() {
    const grid = document.querySelector(GRID_SELECTOR);
    if (!grid) return 4;

    const classes = grid.className;
    const isDesktop = window.innerWidth >= BP_XL;

    if (isDesktop) {
      const desktopMatch = classes.match(/row-cols-(?:xl|lg)-(\d+)/);
      if (desktopMatch) return parseInt(desktopMatch[1], 10);
    }

    const mobileMatch = classes.match(/row-cols-(\d+)(?!\w)/);
    if (mobileMatch) return parseInt(mobileMatch[1], 10);

    return isDesktop ? 4 : 2;
  }

  function bannerColumns(banner, cols) {
    let width;

    if (window.innerWidth >= BP_XL) {
      width = parseInt(banner.dataset.desktopSpan, 10) || 1;
    } else {
      const span = banner.dataset.mobileSpan;
      if (span === 'hidden') return 0;
      width = span === 'half' ? 1 : cols;
    }

    return width > cols ? cols : width;
  }

  function getRowEndFlags(grid, cols) {
    const flags = [];
    const kids = grid.children;
    let col = 0;

    for (let k = 0; k < kids.length; k++) {
      const el = kids[k];

      if (el.classList.contains(BANTOA_CLASS)) continue;

      if (el.hasAttribute('data-plp-banner')) {
        col += bannerColumns(el, cols);
      } else if (el.matches('.col') || el.hasAttribute('data-collection-product')) {
        col += 1;
        flags.push(col % cols === 0);
      }
    }

    return flags;
  }

  function getProductSkus(products) {
    const skus = [];
    for (let i = 0; i < products.length; i++) {
      const el = products[i];
      const wrapper =
        el.querySelector('.data-card-wrapper[data-id]') ||
        el.querySelector('[data-id]');
      if (wrapper && wrapper.dataset.id) {
        skus.push(wrapper.dataset.id);
      }
    }
    return skus;
  }

  function createBantoaRow(index, skus) {
    const row = document.createElement('div');
    row.className = 'col-12 ' + BANTOA_CLASS;
    row.style.cssText = 'flex: 0 0 100%; max-width: 100%; width: 100%;';
    row.dataset.bantoaIndex = index;

    const container = document.createElement('div');
    container.id = 'bantoa-plp-inject-' + index;
    container.style.cssText = 'padding-top:' + PADDING_TOP + 'px; padding-bottom:' + PADDING_BOTTOM + 'px;';
    row.appendChild(container);

    function renderBantoa() {
      if (typeof bnt_r_ai === 'undefined') return;

      const config = {
        selector: '#bantoa-plp-inject-' + index,
        position: 'plp-row-' + index,
        max_outfit: MAX_OUTFIT,
        min_outfit: 1,
        orderByCurrentSeason: true,
        type: ['ai', 'human'],
        renderEventCallback: function (data) {
          if (typeof dataLayer !== 'undefined') {
            dataLayer.push({
              event: 'bantoa_plp_outfit_render',
              bantoa_data: data,
              bantoa_row: index,
            });
          }
        },
        hoverEventCallback: function (data) {
          if (typeof dataLayer !== 'undefined') {
            dataLayer.push({
              event: 'bantoa_plp_outfit_hover',
              bantoa_data: data,
              bantoa_row: index,
            });
          }
        },
        clickEventCallback: function (data) {
          if (typeof dataLayer !== 'undefined') {
            dataLayer.push({
              event: 'bantoa_plp_outfit_click',
              bantoa_data: data,
              bantoa_row: index,
            });
          }
        },
      };

      if (bantoaTitle) {
        config.title = bantoaTitle;
      }

      if (skus.length > 0) {
        config.items = skus;
      }

      bnt_r_ai('render', 'outfit', config);
    }

    const delay = window.isBantoaLoaded ? 100 : 3000;
    row.__bantoaRenderTimer = setTimeout(renderBantoa, delay);

    return row;
  }

  function removeBantoaRow(row) {
    if (row.__bantoaRenderTimer) {
      clearTimeout(row.__bantoaRenderTimer);
      row.__bantoaRenderTimer = null;
    }
    row.remove();
  }

  let isInjecting = false;

  function injectBantoaRows() {
    if (isInjecting) return;
    isInjecting = true;

    const grid = document.querySelector(GRID_SELECTOR);
    if (!grid) {
      isInjecting = false;
      return;
    }

    const cols = getColumnCount();
    const interval = cols * ROWS_INTERVAL;

    const products = grid.querySelectorAll(PRODUCT_SELECTOR);
    if (products.length === 0) {
      isInjecting = false;
      return;
    }

    // Mappa delle righe Bantoa già esistenti, indicizzate per data-bantoa-index
    const existingRows = grid.querySelectorAll('.' + BANTOA_CLASS);
    const existingByIndex = {};
    for (let r = 0; r < existingRows.length; r++) {
      const idxAttr = existingRows[r].dataset.bantoaIndex;
      if (idxAttr != null) {
        existingByIndex[idxAttr] = existingRows[r];
      }
    }

    const allSkus = getProductSkus(products);
    const rowEnds = getRowEndFlags(grid, cols);

    let idx = 0;
    for (let i = interval; i < products.length; i += interval, idx++) {
      let at = i - 1;
      while (at < products.length && !rowEnds[at]) at++;
      if (at >= products.length) continue;

      const productBefore = products[at];
      const idxKey = String(idx);

      if (existingByIndex[idxKey]) {
        // La riga Bantoa per questo indice esiste già: spostala solo se non è più a fine riga
        const existing = existingByIndex[idxKey];
        delete existingByIndex[idxKey]; // marca come "ancora necessaria"
        if (productBefore.nextElementSibling !== existing) productBefore.after(existing);
        continue;
      }

      const startIdx = Math.max(0, at + 1 - cols);
      const endIdx = Math.min(allSkus.length, at + 1 + cols);
      const nearbySkus = allSkus.slice(startIdx, endIdx);

      const bantoaRow = createBantoaRow(idx, nearbySkus);
      productBefore.after(bantoaRow);
    }

    // Rimuovi solo le righe Bantoa che non servono più (e cancella i loro setTimeout pendenti)
    for (const leftoverIdx in existingByIndex) {
      removeBantoaRow(existingByIndex[leftoverIdx]);
    }

    isInjecting = false;
  }

  let debounceTimer;
  function debouncedInject() {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(injectBantoaRows, 300);
  }

  function init() {
    const grid = document.querySelector(GRID_SELECTOR);
    if (!grid) return;

    const observer = new MutationObserver(function (mutations) {
      let hasNewProducts = false;
      for (let m = 0; m < mutations.length; m++) {
        const added = mutations[m].addedNodes;
        for (let n = 0; n < added.length; n++) {
          const node = added[n];
          if (
            node.nodeType === 1 &&
            !node.classList.contains(BANTOA_CLASS) &&
            !node.hasAttribute('data-plp-banner')
          ) {
            if (
              node.classList.contains('col') ||
              node.hasAttribute('data-collection-product')
            ) {
              hasNewProducts = true;
              break;
            }
            if (
              node.querySelector &&
              node.querySelector(
                '.data-card-wrapper[data-id], [data-collection-product]'
              )
            ) {
              hasNewProducts = true;
              break;
            }
          }
        }
        if (hasNewProducts) break;
      }
      if (hasNewProducts) {
        debouncedInject();
      }
    });

    observer.observe(grid, { childList: true });

    let lastCols = getColumnCount();
    window.addEventListener('resize', function () {
      const newCols = getColumnCount();
      if (newCols !== lastCols) {
        lastCols = newCols;
        debouncedInject();
      }
    });

    if (grid.querySelectorAll(PRODUCT_SELECTOR).length > 0) {
      injectBantoaRows();
    }

    window.addEventListener('algolia-search-complete', function () {
      debouncedInject();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
